export default {
  disable: '注销',
  enable: '启用',
  channel: '渠道',
  plant: '仓库',
  addChannel: '新增渠道',
  addPlant: '新增仓库',
  errorcode_499: 'SKU列表未通过检查',
  errorcode_423: '上传的execl包含重复SKU: ',
  errorcode_424: 'Excel包含空白产品代码!',
  errorcode_425: '产品代码里有空格!: ',
  errorcode_1603: '非法的仓库代码: ',
  errorcode_1604: '非法的渠道: ',
  errorcode_801: '上传的文件不能为空',
  errorcode_821: '不是excel文件',
  errorcode_1111: '源文件为空',
  errorcode_1801: '批量插入NFC sku错误',
  errorcode_1304: 'Tag Type 不能为空',
  errorcode_13041: '绑定类型',
  errorcode_13042: '在配置中不存在',
  errorcode_1305: '仅允许5种NFC类型',
  disabledDataTip: '您确定要注销该数据吗?',
  enableDataTip: '您确定要启用该数据吗?',
  createTime: '创建时间',
  lastUpdate: '最后更新',
  lastUploadTime: '最后上传时间',
  lastUpdateTime: '最后更新时间',
  uploadDate: '上传日期',
  createDate: '创建日期',
  updateDate: '更新日期',
  tagType: '绑定类型',
  addTagType: '新增NFC环扣类型',
  editTagType: '编辑NFC环扣类型',
  tagTypeDesc: 'NFC环扣类型描述',
  tagTypeName: 'NFC环扣类型名称',
  lastUpdateUser: '最后更新用户',
  // lastUpdateTime: '最后更新时间',cd
  default: '默认',
  defaultTagType: '默认NFC环扣类型',
  charactersNumbers: '不能超过4个字符',
  inputRequire: '只允许大小写字母和数字',
  descriptionRepeat: '绑定描述已存在!',
  tagTypeRepeat: '绑定类型已存在!',
  totalSKUCount: 'SKU总量: ',
  processSuccessCount: '处理成功数量: ',
  compareWithLastVersion: '与最新版本对比:',
  inactiveSKUCount: '不活跃的SKU数量: ',
  newSKUCount: '新的SKU数量: ',
  upload: '上传',
  export: '导出',
  season: '销售季',
  salesDoor: '销售门店数',
  averageNo: '门店平均展示数量',
  uploadSuccess: '上传成功',
  uploadStoreDisplay_errorcode_501: '销售季是必填的。',
  uploadStoreDisplay_errorcode_502: '产品代码是必填的。',
  uploadStoreDisplay_errorcode_503: '渠道是必填的。',
  uploadStoreDisplay_errorcode_504: '门店平均展示数量是必填的。',
  uploadStoreDisplay_errorcode_505: '销售季的格式应该是SP24。',
  uploadStoreDisplay_errorcode_506: '门店平均展示数量应该是正整数。',
  uploadStoreDisplay_errorcode_507: '重复。',
  templateName: '模板名称',
  templateDescription: '模板描述',
  fieldId: '栏位',
  fieldName: '栏位名称',
  action: '操作',
  editTemplate: '编辑模板',
  addTemplate: '新增模板',
  deleteDataTip: '您确定要删除该数据吗?',
  templateNameError: `模板名称是必填的。`,
  fieldListError: '请输入至少一个栏位名称。',
  addTemplateError: `模板名称 + 栏位 + 栏位名称不能重复。`,
  addTemplateError2: `模板名称不能重复。`,
  uploadTagImage: '上传NFC环扣图片',
  tagTypeImage: 'NFC环扣类型图片',
  fileSizeErrTip: '图片大小不能超过',
  fileExtentionError: '文件扩展名必须是',
  exportLatestStoreDisplay: '导出最新门店展示',
  addRFDevice: '新增扫码枪',
  editRFDevice: '编辑扫码枪',
  deviceCode: '扫码枪编号',
  macAddress: '无线网卡Mac地址',
  RFDeviceStatus: '扫码枪状态',
  updateTime: '更新时间',
  errTitleExist: '扫码枪编号/Mac地址重复',
  errMsgExist: '此扫码枪编号/Mac地址已存在。',
  errTitleMac: '无线网卡Mac地址错误',
  errMsgMac: '请输入正确的Mac地址格式, 如： F4-7B-09-40-87-7B',
  errTitleDeviceCode: '扫码枪编号错误',
  errMsgDeviceCode: ' 请采用无空格大写字母或数字，输入正确的扫码枪编号格式, 如： 1025RFID-XXX-001',
  errTitleModuleConflict: '扫码枪功能模块冲突',
  errMsgModuleConflict: '复检功能不可同时配置于1025和1027。',
  disableRFDeviceConfirmInfo: '确认禁用此扫码枪吗？',
  function: '功能模块'
}
